import { createContext, useContext } from 'react';

/** Сообщить виртуализатору перемерить строку (после изменения высоты в ячейке, напр. раскрытие среза). */
export const VirtualRowRemeasureContext = createContext<(() => void) | null>(null);

export function useVirtualRowRemeasure(): (() => void) | null {
  return useContext(VirtualRowRemeasureContext);
}
